// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import InitRouter from '@/router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import './assets/style/index.scss'
import Filters from '@/common/filter'
import LocalStorage from '@/plugin/localstorage'
import Directive from '@/common/directive'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Filters)
Vue.use(LocalStorage)
Vue.use(Directive)
InitRouter()
// function resizeFun () {
//   let hheight = document.body.clientHeight
//   let height = 1080
//   let transform = ''
//   if (height > hheight) {
//     var captchaScale = hheight / height
//     transform = 'transform:scale(' + captchaScale + ');transform-origin:left top;-webkit-transform-origin:left top;margin:0 auto;'
//   } else {
//     transform = 'transform:unset'
//   }
//   // this.OlViewStyle = Object.assign({}, this.OlViewStyle, transform);
//   let bodyheight = document.getElementsByTagName('body')
//   bodyheight[0].setAttribute('style', transform)
// }
// resizeFun()
// window.addEventListener(
//   'resize',
//   () => {
//     resizeFun()
//   },
//   false
// )



// WEBPACK FOOTER //
// ./src/main.js